// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthorizedContentContainer_container__2LqOn"};